import { render, staticRenderFns } from "./PropertyReportPreview.vue?vue&type=template&id=ffb8ca50&scoped=true&"
import script from "./PropertyReportPreview.vue?vue&type=script&lang=ts&"
export * from "./PropertyReportPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb8ca50",
  null
  
)

export default component.exports